import Collection from './collection.js';
import PayslipDetail from 'newModels/payslip-detail.js';
import PayrollItemFilters from './mixins/payroll-item-filters.js';

import Decimal from 'decimal.js';

export default class PayslipDetails extends PayrollItemFilters(Collection) {
    url() {
        if (this.payslip) {
            return `${this.payslip.url()}/details`;
        }

        return `/PayslipDetails`;
    }

    initialize(models, {payslip = null} = {}) {
        this.model = PayslipDetail;
        this.payslip = payslip;
        return super.initialize(...arguments);
    }

    // TODO we need the payroll items to sort, so we need to figure out
    // a way for them to be included when this run
    comparator(a, b) {
        // jscs:disable requireCamelCaseOrUpperCaseIdentifiers
        const weightByType = {
            base:         100,
            addition:     90,
            benefit:      80,
            deduction:    70,
            unpaid_leave: 65,
            cp38:         63,
            mtd:          60,
            epf:          50,
            socso:        40,
            zakat:        30
        };
        // jscs:enable requireCamelCaseOrUpperCaseIdentifiers
        const itemA = a.getPayrollItem();
        const itemB = b.getPayrollItem();

        if (a.get('isAdditional') > b.get('isAdditional')) {
            return 1;
        }

        if (a.get('amount') < b.get('amount')) {
            return 1;
        }

        if (!itemA || !itemB) {
            return 1;
        }

        if (
            weightByType[itemA.get('type')] <
            weightByType[itemB.get('type')]
        ) {
            return 1;
        }
    }

    setPayslip(payslip) {
        this.payslip = payslip;
    }

    /**
     * Get payslip details that have an amount attr larger than 0 in a brand
     * new collection
     *
     * @instance
     * @todo TODO Why is this called current?
     * @returns {module:collections.PayslipDetails}
     */
    current() {
        return new Collection(_.clone(this.filter(model => {
            return (model.get('amount') || 0) > 0;
        })));
    }

    /**
     * Get the sum of all items' amount (regardless of payroll item config)
     *
     * @instance
     * @returns {Number}
     */
    getFullAmount() {
        return this.reduce((memo, model) => {
            return memo.plus(model.get('fullAmount') || 0);
        }, new Decimal(0)).toDP(2, Decimal.ROUND_HALF_UP).toNumber();
    }

    /**
     * Get the sum of all items that affect the net amount
     *
     * @instance
     * @returns {Number}
     */
    getNetAmount() {
        return this.reduce((memo, detail) => {
            const payrollItem = detail.getPayrollItem();
            if (payrollItem && payrollItem.get('isNet')) {
                return memo.plus(detail.getRealAmount() || 0);
            }
            return memo;
        }, new Decimal(0)).toDP(2, Decimal.ROUND_HALF_UP).toNumber();
    }

    /**
     * Create a new collection with all payslip details that are affected by
     * unpaid leave
     *
     * @instance
     * @returns {module:collections.PayslipDetails}
     */
    findAffectedByUnpaidLeave() {
        return new PayslipDetails(this.filter(model => {
            return model.get('isUnpaidLeave') === true;
        }), {payslip: this.payslip});
    }
}



// WEBPACK FOOTER //
// ./app/new-collections/payslip-details.js